import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import logo from "../../assets/images/img/genvix_tech_logo.png";
import phone_icon from "../../assets/images/navbar/phone.svg";
import fb_icon from "../../assets/images/navbar/facebook.svg";
import insta_icon from "../../assets/images/navbar/instagram.svg";
import linkedin_icon from "../../assets/images/navbar/linkedin.svg";
import whatsapp_icon from "../../assets/images/navbar/whatsapp.png";
import mail_icon from "../../assets/images/navbar/mail.svg";
import NavbarIcon from "../../assets/images/navbar/navbar icon.webp";
import Outline from "../../assets/outline-1.png";

import "../../styles/module/footer.css";

const quickLinks = [
  { label: "Web & Mobile App Development", url: "/services/web-mobile-app" },
  { label: "Website Management", url: "/services/website-management" },
  { label: "Website Customization", url: "/services/website-customization" },
  { label: "Graphic Design & Branding", url: "/services/desing-branding" },
  { label: "Data Analytics & Insights", url: "/services/analytics-insights" },
  { label: "API & System Integration", url: "/services/api-integration" },
];

export default function Footer() {
  useScrollReveal("slide-from-bottom");
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  return (
    <footer>
      <div className="container footer">
        <div className="drop-from-top">
          <img
            loading="lazy"
            alt="footer background"
            src={Outline}
            className="image-background footer__background-image"
          />
        </div>

        {/* Open Hours Column */}
        <div className="footer__column footer__open-hours slide-from-left">
          <a href="/">
            <img
              loading="lazy"
              src={logo}
              alt="Genvix Tech"
              className="site-logo site-logo-footer"
              width="186"
            />
          </a>
          <div className="footer__columnn-content">
            <h6 className="footer__title footer__title--margin">
              Business Hours:
            </h6>
            <p className="footer__paragraph">
              Days: <strong>Sunday - Friday</strong>
            </p>
            <p className="footer__paragraph">
              Hours: <strong>10AM - 6PM</strong>
            </p>
          </div>
        </div>

        {/* Useful Links Column */}
        <div className="footer__column slide-from-left">
          <h6 className="footer__title">Quick Links: </h6>
          <div>
            <ul className="quick-links-list">
              {quickLinks.map((item, index) => (
                <li key={index} className="quick-link-item">
                  <img
                    src={NavbarIcon}
                    alt="icon"
                    className="quick-link-icon"
                  />
                  <a href={item.url} className="quick-link-text">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social Media Column */}
        <div className="footer__column slide-from-right">
          <h6 className="footer__title">Stay connected with us.</h6>
          <p className="footer__paragraph">
            Follow our social channels for a behind-the-scenes look at our work,
            culture, and daily updates.
          </p>
          <div className="footer__icons">
            <a
              target="_blank"
              rel="nofollow noreferrer"
              href="https://www.facebook.com/genvixtech"
            >
              <img loading="lazy" src={fb_icon} alt="Facebook" />
            </a>
            <a
              target="_blank"
              rel="nofollow noreferrer"
              href="https://www.instagram.com/genvixtech"
            >
              <img loading="lazy" src={insta_icon} alt="Instagram" />
            </a>
            <a
              target="_blank"
              rel="nofollow noreferrer"
              href="https://www.linkedin.com/company/genvixtech"
            >
              <img loading="lazy" src={linkedin_icon} alt="LinkedIn" />
            </a>
            <a
              target="_blank"
              rel="nofollow noreferrer"
              href="https://wa.me/9779762688171?text=Hello%20Genvix%20Tech,%20I%20would%20like%20to%20inquire%20about%20your%20services."
            >
              <img loading="lazy" src={whatsapp_icon} alt="WhatsApp" />
            </a>
          </div>
        </div>

        {/* Contact Column */}
        <div className="footer__column slide-from-right">
          <h6 className="footer__title">Have questions? We're here to help.</h6>
          <p className="footer__paragraph contact">
            Reach out to us anytime—we’re happy to provide answers, support, or
            guidance.
          </p>
          <div className="footer__icon-box">
            <img
              loading="lazy"
              alt="phone"
              src={phone_icon}
              className="footer__icon-single"
            />
            <a className="phone-clickable" href="tel:+9779762688171">
              <p className="footer__paragraph">+977-9762688171</p>
            </a>
          </div>
          <div className="footer__icon-box">
            <img
              loading="lazy"
              alt="email"
              src={mail_icon}
              className="footer__icon-single"
            />
            <a href="mailto:info@genvixtech.com">
              <p className="footer__paragraph">info@genvixtech.com</p>
            </a>
          </div>
        </div>
      </div>

      <div className="copyright container slide-from-bottom">
        <div>
          <p className="footer__paragraph container">
            © {new Date().getFullYear()} Genvix Tech. All rights reserved.
          </p>
        </div>
        <a className="footer-links" href="/privacy-policy">
          <p className="footer__paragraph container footer-links">Privacy Policy</p>
        </a>
        <a className="footer-links" href="/terms-of-use">
          <p className="footer__paragraph container footer-links">
            Terms of Use
          </p>
        </a>
      </div>
    </footer>
  );
}
